import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Col, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { FormattedMessage, useIntl } from "react-intl";
import Loader from "components/shared/Loader";
import { Input } from "components/shared/FormComponents";
import AddButton from "components/shared/AddButton";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import { useState } from "react";
import ImageUpload from "components/shared/ImageUpload";
import { addSection } from "store/actions";

const AddSocialLink = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedImage, setSelectedImage] = useState({
    preview: null,
    path: "",
  });
  const { loading, error } = useSelector((state) => state.section);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  // error
  useEffect(() => {
    if (error) {
      toastErrorMessage(formatMessage({ id: "sendingErrorMessage" }), locale);
    }
  }, [error, formatMessage, locale]);

  const onSubmit = (data) => {
    if (!selectedImage?.path) {
      toastErrorMessage(formatMessage({ id: "imageErrorMessage" }), locale);
      return;
    }
    data.image = selectedImage?.path;
    data.title = data?.name?.en;

    dispatch(
      addSection({
        page: "socialLinks",
        redirect: "socialLinks",
        data: { section: data },
        navigate,
      })
    );
  };

  if (loading) return <Loader />;

  return (
    <>
      <div className="acc-form">
        <div className="card">
          <div className="card-head">
            <h4>
              <FormattedMessage id={"addSocial"} />
            </h4>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit(onSubmit)}>
              {/* <Col xl={8} md={12}> */}
              {/* image  */}

              <Row>
                <Col lg={12} xs={12}>
                  <div className="form-group required">
                    <h5>
                      <FormattedMessage id={"icon"} />
                    </h5>

                    <ImageUpload
                      selectedImage={selectedImage}
                      setSelectedImage={setSelectedImage}
                    />
                  </div>
                </Col>
              </Row>

              {/* name  */}
              <Row>
                <Col md={6} xs={12}>
                  <Input
                    langId="name"
                    name="name.ar"
                    register={register}
                    errors={errors}
                  />
                </Col>

                <Col md={6} xs={12}>
                  <Input
                    langId="name"
                    name="name.en"
                    register={register}
                    errors={errors}
                  />
                </Col>

                {/* </Row>
                <Row> */}
                <Col md={6} xs={12}>
                  <Input
                    langId="link"
                    name="link"
                    register={register}
                    errors={errors}
                  />
                </Col>
              </Row>

              <AddButton />
              {/* </Col> */}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddSocialLink;
